import { memo } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { Button } from 'src/modules/common/components/Button/Button';
import { ExitIcon } from 'src/modules/common/icons/ExitIcon';
import { CartIcon } from 'src/modules/common/icons/CartIcon';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';

type Props = {
    onButtonClick: () => void;
}

export const SelectedProducts = memo(({ onButtonClick }: Props) => (
    <div className="vss-selected-products">
        <div className="vss-selected-products__icons">
            <div className="vss-selected-products__icon">
                <ExitIcon/>
            </div>

            <div className="vss-selected-products__icon">
                <CartIcon/>
            </div>
        </div>

        <h2 className="vss-selected-products__title">
            <I18n messageId={MESSAGES.selectedProductsDescription}/>
        </h2>

        <Button size="lg" onClick={onButtonClick}>
            <I18n messageId={MESSAGES.selectMoreProducts}/>

            <div className="vss-selected-products__button-icon">
                <ArrowRightIcon/>
            </div>
        </Button>
    </div>
));
